module.exports = __webpack_public_path__ + "0614c27197fc3ce572e161840d23b2af.png";